import React from "react";

const LazyTeamImage = React.lazy(() => import("./teamImage"));

const TeamImage = (props: Record<string, any>) => (
  <React.Suspense fallback={null}>
    <LazyTeamImage {...props} />
  </React.Suspense>
);

export default TeamImage;
